export default {"src":"/_next/static/media/situation-mental-health.70e72b6c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};